/**
 * Turns a raw backend or network failure message into a plain reason. The raw text is only used to
 * pick a reason and is never returned, so stack traces, tool names and job ids cannot leak to the
 * screen. Matching is case-insensitive and checked in this order: timeout, size or length, file format.
 * Format patterns name the audio or file explicitly so an unrelated message ("decodeURIComponent
 * failed", "Unsupported operation") falls back.
 */
const ERROR_RULES: ReadonlyArray<{ pattern: RegExp; message: string }> = [
  {
    pattern: /time(?:d)?[\s_-]?out|took too long|deadline/i,
    message: "Processing took too long. Please try again.",
  },
  {
    pattern: /too (?:large|long|big)|longer than|exceeds? (?:the )?(?:max|limit|duration|size|length)|file size|\b413\b|max(?:imum)? (?:duration|length|size)/i,
    message: "This recording is longer than we can process right now.",
  },
  {
    pattern: /(?:file|audio|invalid|unknown|unsupported) format|corrupt|codec|(?:failed|unable|cannot|can't) (?:to )?decode|decoding (?:error|failed)|unsupported (?:file|audio|media|codec|encoding|type)|unrecogni[sz]ed (?:file|audio|format)|invalid (?:data|audio|file)|ffmpeg|ffprobe|moov atom/i,
    message: "We couldn't read this audio file. Try another format such as MP3 or M4A.",
  },
];

export const FALLBACK_ERROR = "Something went wrong while processing. Please try again or contact support.";

export function toFriendlyError(errorMessage?: string | null): string {
  const raw = typeof errorMessage === "string" ? errorMessage : "";
  const rule = ERROR_RULES.find(({ pattern }) => pattern.test(raw));
  return rule ? rule.message : FALLBACK_ERROR;
}
